import { TCommonVersion } from '../types/items.types';

const IS_BACKEND = false;

// IMPORTANT: THIS METHOD IS SHARED BETWEEN FRONTEND AND BACKEND:

const checkVersionId = (
  versionId: string,
  versions: TCommonVersion[],
  originalVersionId?: string
): string | undefined => {
  const pattern = /^(0|[1-9]\d*)\.(0|[1-9]\d*)$/; // also checks for leading zero (e.g. "001.4")
  if (!pattern.test(versionId)) return 'Version-id must be in the format of x.y!';
  if (versionId === '0.0') return 'Version-id cannot be 0.0!';

  const [major, minor] = versionId.split('.').map((number) => parseInt(number));

  const prevIdx = IS_BACKEND ? versions.length - 2 : 1;
  const prevVersionId = versions[prevIdx]?.id || originalVersionId || '0.0';
  const [prevMajor, prevMinor] = prevVersionId.split('.').map((number) => parseInt(number));

  if (major < prevMajor || (major === prevMajor && minor <= prevMinor))
    return `Please choose a version higher than the previous version ${prevVersionId}!`;
};

export default checkVersionId;
